import { render, staticRenderFns } from "./channel-osd.vue?vue&type=template&id=6dbd818c&scoped=true&lang=pug"
import script from "./channel-osd.vue?vue&type=script&lang=js"
export * from "./channel-osd.vue?vue&type=script&lang=js"
import style0 from "./channel-osd.vue?vue&type=style&index=0&id=6dbd818c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbd818c",
  null
  
)

export default component.exports